export type BlogUnavailableProps = {
  unavailable: true;
  path: `/${string}`;
};

export const isBlogUnavailable = (
  props: object
): props is BlogUnavailableProps => {
  return (
    'unavailable' in props &&
    (props as { unavailable?: unknown }).unavailable === true
  );
};
